var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultReducerState = {
  userManagementGroup: {
    data: null,
    isLoading: false,
    error: ""
  },
  updatingManagementGroup: false
};
const updateManagementGroupPrefix = "updateManagementGroup";
const updateManagementGroupActionTypes = {
  LOAD: `${updateManagementGroupPrefix}/LOAD`,
  LOADING: `${updateManagementGroupPrefix}/LOADING`,
  LOADED: `${updateManagementGroupPrefix}/LOADED`
};
const afterUpdateManagementGroupActionType = "afterUpdateManagementGroup";
const updateManagementGroup = (workspaceId, managementGroup, onUpdated) => {
  return {
    type: updateManagementGroupActionTypes.LOAD,
    managementGroup: {
      data: { workspaceId, managementGroup },
      isLoading: false,
      error: ""
    },
    onUpdated
  };
};
const updatingManagementGroup = () => {
  return {
    type: updateManagementGroupActionTypes.LOADING
  };
};
const updatedManagementGroup = (managementGroup) => {
  return {
    type: updateManagementGroupActionTypes.LOADED,
    managementGroup
  };
};
const afterUpdatedManagementGroup = (onUpdated) => {
  return {
    type: afterUpdateManagementGroupActionType,
    onUpdated
  };
};
const managementGroupProviderReducer = (state = defaultReducerState, action) => {
  var _a;
  switch (action.type) {
    case updateManagementGroupActionTypes.LOADING:
      return __spreadProps(__spreadValues({}, state), {
        userManagementGroup: __spreadProps(__spreadValues({}, state.userManagementGroup), {
          isLoading: true
        }),
        updatingManagementGroup: true
      });
    case updateManagementGroupActionTypes.LOADED:
      return __spreadProps(__spreadValues({}, state), {
        userManagementGroup: (_a = action.managementGroup) != null ? _a : {
          data: null,
          isLoading: false,
          error: "Error loading user management group"
        },
        updatingManagementGroup: false
      });
    default:
      return state;
  }
};
export {
  afterUpdateManagementGroupActionType,
  afterUpdatedManagementGroup,
  managementGroupProviderReducer as default,
  defaultReducerState,
  managementGroupProviderReducer,
  updateManagementGroup,
  updateManagementGroupActionTypes,
  updatedManagementGroup,
  updatingManagementGroup
};
//# sourceMappingURL=ManagementGroupProvider.ducks.js.map
